




















































































import { defineComponent, toRefs, PropType } from '@vue/composition-api';
import {
  AdgroupFormData,
  AdType,
  CampaignFormData,
  CreativeConfig,
  FullNormalFormData,
  NormalCreative,
} from '@tt4b/ttam-enums';
import { useStdCreativeAdgroupIs, useCreativeIs, useAdType, useCreativeActionTypeIs } from '@tt4b/ttam-hooks';

import AdFormat from './index';

const name = 'ttam-ad-format-compose';
export default defineComponent({
  name,
  components: {
    TtamAdFormatLeadAdType: AdFormat.TtamAdFormatLeadAdType,
    TtamAdFormatNormalAdType: AdFormat.TtamAdFormatNormalAdType,
    TtamAdFormatManualChooseHeader: AdFormat.TtamAdFormatManualChooseHeader,
    TtamAdFormatCatalogChooseHeader: AdFormat.TtamAdFormatCatalogChooseHeader,
  },
  props: {
    isIconVisible: { type: Boolean, default: false },
    isCollectionAdsSelectorSupportable: { type: Boolean, default: false },
    currentAdType: {
      type: Number as PropType<AdType>,
      default: undefined,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: 'create',
    },
    normalCreativeData: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
    creativeConfig: {
      type: Object as PropType<CreativeConfig>,
      default: () => ({}),
    },
    firstCreativeInfo: {
      type: Object as PropType<any>,
      default: () => ({}),
    },
    isDefaultCatalogCarousel: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const {
      createMode,
      campaignData,
      adgroupData,
      creativeData,
      normalCreativeData,
      currentAdType,
      isCollectionAdsSelectorSupportable,
      creativeConfig,
      firstCreativeInfo,
    } = toRefs(props);
    const { isEdit, isCreate, isCopy } = useCreativeActionTypeIs({ createMode, adgroupFormData: adgroupData });

    const { isNative, isCollectionAdsCreative } = useCreativeIs({
      createMode,
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      normalCreativeData,
    });

    const { isLeadAds, isLiveAds, isOnlySupportTT } = useStdCreativeAdgroupIs({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });

    const { isCollectionAdsTypeVisible } = AdFormat.usePropsIsCollectionAdsTypeVisible({
      isEdit,
      isCollectionAds: isCollectionAdsCreative,
      isCollectionAdsSelectorSupportable,
    });
    const { supportAdTypeList } = useAdType({
      isNative,
      isOnlySupportTikTok: isOnlySupportTT,
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      creativeFormData: creativeData,
    });

    const { adTypeList, normalType, catalogType } = AdFormat.usePropsAdTypeList({
      isEdit,
      isNative,
      isLiveAds,
      currentAdType,
      supportAdTypeList,
    });

    const { disabled } = AdFormat.usePropsDisabled({
      creativeConfig,
    });

    const { list } = AdFormat.useHandlerAdTypeList({
      adTypeList,
      firstCreativeInfo,
      campaignData,
      creativeData,
      adgroupData,
      isCreate,
      isCopy,
      emit,
    });
    function onNormalChange(type) {
      emit('normal-change', type);
    }

    function onCaChange() {
      emit('ca-change');
    }

    return {
      name,
      isNative,
      disabled,
      isLeadAds,
      isLiveAds,
      adTypeList: list,
      catalogType,
      normalType,
      supportAdTypeList,
      isCollectionAdsCreative,
      isCollectionAdsTypeVisible,
      onCaChange,
      onNormalChange,
    };
  },
});
